export default "__VITE_ASSET__Il3NZ6Dl__"